"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.guessTypeForField = exports.guessFormatForField = void 0;
exports.guessFormatForField = (field) => {
    if (!field) {
        return "{0}";
    }
    if (field.startsWith("Is")) {
        return "{0}";
    }
    if (field.includes("Cost") ||
        field.includes("Price") ||
        field.includes("Amount")) {
        return "{0:c}";
    }
    if (field.includes("DateTime")) {
        return "{0:g}";
    }
    if (field.includes("Date")) {
        return "{0:d}";
    }
    return "{0}";
};
exports.guessTypeForField = (field) => {
    if (!field) {
        return undefined;
    }
    if (field.startsWith("Is")) {
        return "boolean";
    }
    if (field.endsWith("Id")) {
        return "numeric";
    }
    if (field.includes("Cost") ||
        field.includes("Price") ||
        field.includes("Amount")) {
        return "numeric";
    }
    if (field.includes("DateTime")) {
        return "date";
    }
    if (field.includes("Date")) {
        return "date";
    }
    return "text";
};
//# sourceMappingURL=zGridUtils.js.map